export const DEFAULT_SPONSOR_CATEGORIES = [
  { key: 'main', label: 'Ana Sponsorlar', layout: 'strip' },
  { key: 'vip', label: 'VIP Sponsorlar', layout: 'cards' },
  { key: 'trusted', label: 'Güvenilir Sponsorlar', layout: 'rows' },
];

export const flattenSponsorGroups = (data) => (
  Object.values(data || {}).filter(Array.isArray).flat()
);
